<template>
  <v-container fill-height container--fluid >
      <v-row>
          <v-col cols="12">
              <v-breadcrumbs
              :items="breadCrumbsItems"
                divider=">"
                ></v-breadcrumbs>
          </v-col>
      </v-row>
      <v-row class="mb-3">
          <v-col cols="12" sm="12" md="12" lg="12">
            <client-quality-rating theme="#36a2eb" 
            :title="CLIENT_RATING.title" 
            :headers="clientHeaders" 
            :items="CLIENT_RATING.items" 
            :filterCampaigns="filterCampaigns"
            :filterUsers="filterUsers"
            filterUserLabel="AM Filter"
            @searchfilter="clientSearch" />
          </v-col>
      </v-row>
  </v-container>
</template>
<script>
import { mapState } from 'vuex';

// Components
import userAPIs from '../User/userAPIs';
import QualityRatingHelper from '../DashboardComponents/QualityRatingHelper'
import InfluencerQualityRating from '../DashboardComponents/InfluencerQualityRating.vue'
import ClientQualityRating from '../DashboardComponents/ClientQualityRating.vue'
import config from '@/config';
import PieChart from '../DashboardComponents/Chart/Pie.vue';

export default {
  name: 'Quality',
  components: {
    InfluencerQualityRating,
    ClientQualityRating,
    PieChart
  },
  data() {
    return {
      campaigns: [],
      filterCampaigns: [],
      filters: {},
      breadCrumbsItems: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/am/dashboard'
        },
        {
          text: 'Quality',
          disabled: true,
          href: ''
        }
      ],
      AMUsers: [],
      filterUsers: [],
      clientHeaders: [
        { value: 'name', text: 'Campaign', sortable: true },
        { value: 'vertical', text: 'Vertical', sortable: true },
        { value: 'budget', text: 'Budget', sortable: true },
        { value: 'avg_influencers_selection', text: 'Average Rating on Selection', sortable: true },
        { value: 'avg_draft_post', text: 'Average Rating on Drafts', sortable: true },
        { value: 'avg_campaign_timeline_rate', text: 'Average Rating on Timeline', sortable: true },
        { value: 'avg_content_quality_rate', text: 'Average on Content Quality', sortable: true },
        { value: 'avg_overall_experience_rate', text: 'Average on Overall Experience with KOBE', sortable: true },
        { value: 'overall_rate', text: 'Overall Score', sortable: true }
      ],
      CLIENT_RATING: {
        title: 'Client Rating',
        items: []
      },
      clientAvgRatings: []
    }
  },
  computed: {
    ...mapState(['user']),
    currentUserRole: function() {
      return this.user.role;
    },
    currentUserID: function() {
      return this.user.id;
    }
  },
  mounted() {
    QualityRatingHelper
    .getAllCampaignsNoStatus()
    .then(response => {
      this.campaigns = response
      this.filterCampaigns = response
      this.filterCampaigns.unshift({id: '', name: 'All Campaigns'})
      this.getClientAvgRatings()
    })
    .catch(error => {
      // Request failed.
      this.isLoading = false;
      console.log('error', error);
    });

    // Get all CO user by role
    userAPIs
    .getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
    .then(response => {
      this.AMUsers = response.users
      this.filterUsers = response.users.map(user => {
        user.name = `${user.firstName} ${user.lastName}`
        return user
      })
      this.filterUsers.unshift({id: '', name: 'All Team'})
    })
    .catch(error => {
      console.log('error', error);
    });
  },
  methods: {
    clientSearch(filters) {
      this.filters = filters
      this.getClientAvgRatings()
    },
    getClientAvgRatings() { // Client Average Ratings
      let queryFilter = Object.assign({}, {month: this.filters.month ? this.filters.month : ''});
      QualityRatingHelper
      .getClientAvgRatings(queryFilter, true)
      .then(response => {
        this.clientAvgRatings = response.ratings
        this.CLIENT_RATING.items = []
        this.CLIENT_RATING.items = this.calculateClientAvgOverall(this.filterAvgRatings(this.clientAvgRatings, this.filters))
      })
      .catch(error => {
        // Request failed.
        this.isLoading = false;
        console.log('error', error);
      });
    },
    filterAvgRatings(allAvgRatings, filters) {
      let filteredCampaigns = this.campaigns.filter(c => allAvgRatings.some(v => c.id === (v._id && v._id.campaignID)))
      filteredCampaigns.map(c => {
        let avgRatings = allAvgRatings.filter(function (avg) { return (avg._id && avg._id.campaignID) === c.id })
        if (avgRatings.length) {
          avgRatings.map(ar => {
            Object.assign(c, ar)
          })
        }
      })
      // filter for selected Campaigns
      if (filters.CampaignId && filters.CampaignId !== '') {
        filteredCampaigns = filteredCampaigns.filter(c => c.id === filters.CampaignId)
      }

      // filter for CO
      if (filters.UserId && filters.UserId !== '') {
        filteredCampaigns = filteredCampaigns.filter(c => (c.assignedTo && c.assignedTo.includes(filters.UserId)))
      }
      return filteredCampaigns
    },
    calculateClientAvgOverall(filteredCampaigns) {
      let avgValues = [
        'avg_influencers_selection',
        'avg_content_quality_rate',
        'avg_campaign_timeline_rate',
        'avg_overall_experience_rate',
        'avg_draft_post'
      ]
      filteredCampaigns = filteredCampaigns.map(v => {
        let totalAvgs = 0
        avgValues.map(akey => {
          v[akey] = v[akey] ? Math.round(v[akey]) : 0
          totalAvgs += v[akey]
        })
        v.overall_rate = Math.round(totalAvgs / avgValues.length)
        return v
      })
      return filteredCampaigns
    }
  }
}
</script>
<style scoped>
@font-face {
    font-family: WorkSans-Regular;
    src: url('/static/fonts/WorkSans-Regular.ttf');
}
@font-face {
    font-family: WorkSans-ExtraLight;
    src: url('/static/fonts/WorkSans-ExtraLight.ttf');
}
@font-face {
    font-family: WorkSans-SemiBold;
    src: url('/static/fonts/WorkSans-SemiBold.ttf');
}
@font-face {
    font-family: WorkSans-Medium;
    src: url('/static/fonts/WorkSans-Medium.ttf');
}
</style>



// WEBPACK FOOTER //
// quality.vue?5821baa1